var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#/"}},[_c('img',{staticClass:"dgbrt-mini-header-logo",attrs:{"src":_vm.getImgUrl('logos/logo-b-horizontal.png')}})])}
var staticRenderFns = []

export { render, staticRenderFns }